import { render, staticRenderFns } from "./Sldentify.vue?vue&type=template&id=0ec7e0cd&scoped=true"
import script from "./Sldentify.vue?vue&type=script&lang=js"
export * from "./Sldentify.vue?vue&type=script&lang=js"
import style0 from "./Sldentify.vue?vue&type=style&index=0&id=0ec7e0cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7e0cd",
  null
  
)

export default component.exports